import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";

import { Button } from "@material-ui/core";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import { alertError, alertSuccess } from "../../../../utils/logger";
import {
  getDealById,
  skipNdaToNbo as skipNdaToNboApi,
} from "../../../../api/deal";
import MultiTabBlock from "../../../components/MultiTabBlock";

import DealDocument from "./DealDocument";
import DataroomTab from "../../../components/dataRoom/DataRoomTab";
import NBOTableBackoffice from "../../../components/NBOTableBackoffice";
import NBOTab from "./NBOTab";
import QATab from "./QATab";

export default function WatchDealPage() {
  const history = useHistory();
  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  const dealId = useParams().id;
  const [deal, setDeal] = useState(null);
  const [skipNdaLoading, setSkipNdaLoading] = useState(false);

  useEffect(() => {
    if (!dealId) {
      disableLoadingData();
      return;
    }

    getDealById(dealId)
      .then((res) => {
        setDeal(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get deal." });
        disableLoadingData();
      });
  }, [dealId, disableLoadingData, history]);

  const handleDealUpdate = (updatedDeal) => {
    setDeal(updatedDeal);
  };

  const handleSkipNdaToNbo = () => {
    if (
      !dealId ||
      !window.confirm(
        "¿Avanzar a NBO sin firmar el NDA? El estado del NDA no cambiará.",
      )
    ) {
      return;
    }
    setSkipNdaLoading(true);
    skipNdaToNboApi(dealId)
      .then((res) => {
        setDeal(res.data);
        alertSuccess({
          customMessage: "Deal actualizado a NBO (NDA sin firmar).",
        });
      })
      .catch((error) => {
        alertError({
          error,
          customMessage:
            error.response?.data?.message || "No se pudo avanzar el deal.",
        });
      })
      .finally(() => setSkipNdaLoading(false));
  };

  function getMultiTabColumns() {
    const columnsTab = [
      "NDA",
      "Dataroom",
      "NBO",
      "Final Offer",
      "Contract",
      "Q&A",
    ];

    if (deal?.nbo?.statusOffer === "accepted" && deal?.nbo?.exclusivity) {
      const index = columnsTab.indexOf("NBO");

      if (index !== -1) {
        columnsTab.splice(index + 1, 0, "Exclusivity");
      }
    }

    return columnsTab;
  }

  const renderMultiTabContent = (tabName) => {
    if (tabName === "NDA") {
      return (
        <>
          {deal?.currentStep === "nda" && deal?.status === "accepted" && (
            <div className="mb-3 d-flex justify-content-end">
              <Button
                color="primary"
                variant="contained"
                disabled={skipNdaLoading}
                onClick={handleSkipNdaToNbo}
              >
                {skipNdaLoading
                  ? "Actualizando…"
                  : "Saltar NDA → NBO (sin firma)"}
              </Button>
            </div>
          )}
          <DealDocument
            document={deal?.nda?.doc}
            signed={deal?.nda?.status !== "not signed"}
            envelopedId={deal?.nda?.envelopedId}
          />
        </>
      );
    } else if (tabName === "Dataroom") {
      return (
        <DataroomTab
          id={deal?._id}
          path={"deals"}
          deal={deal}
          onDealUpdate={handleDealUpdate}
        />
      );
    } else if (tabName === "NBO") {
      //return <NBOTab nbo={deal?.nbo} />
      const nbos = Array.isArray(deal?.nbo)
        ? deal.nbo
        : deal?.nbo
        ? [deal.nbo]
        : [];
      return <NBOTableBackoffice nbos={nbos} />;
    } else if (tabName === "Exclusivity") {
      return (
        <DealDocument
          document={deal?.exclusivity?.doc}
          signed={
            deal?.exclusivity?.status &&
            deal?.exclusivity?.status !== "not signed"
          }
          envelopedId={deal?.exclusivity?.envelopedId}
        />
      );
    } else if (tabName === "Final Offer") {
      return <NBOTab nbo={deal?.finalOffer} />;
    } else if (tabName === "Contract") {
      return (
        <DealDocument
          document={deal?.contract?.doc}
          signed={
            deal?.contract?.status && deal?.contract?.status !== "not signed"
          }
          envelopedId={deal?.contract?.envelopedId}
        />
      );
    } else if (tabName === "Q&A") {
      return <QATab questions={deal?.project?.faqs} dealId={deal?._id} />;
    }
  };

  if (isLoadingData) return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-12 ">
              <MultiTabBlock
                multiTabContent={renderMultiTabContent}
                columns={getMultiTabColumns()}
                step={deal?.currentStep}
              />
            </div>
          </div>
        </CardBody>
      </Card>

      <Button
        onClick={() => history.push("/deals")}
        variant="outlined"
        style={{ marginRight: 20 }}
      >
        Back
      </Button>
    </>
  );
}
